import { render, staticRenderFns } from "./Archive.vue?vue&type=template&id=0d8019e6&scoped=true"
import script from "./Archive.vue?vue&type=script&lang=js"
export * from "./Archive.vue?vue&type=script&lang=js"
import style0 from "./Archive.vue?vue&type=style&index=0&id=0d8019e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8019e6",
  null
  
)

export default component.exports